import React from 'react';
import { Space } from 'antd';
import { ButtonCommon } from '../Button/ButtonCommon';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import { ArrowLeft, ArrowRight, Circle, GlobeHemisphereEast } from '@phosphor-icons/react';
import { ToolbarForLayoutTwoColProps } from 'types';
import ToolbarLayout from './ToolbarLayout';
import { formatDate } from 'utils';
import { useMediaQuery } from 'react-responsive';
import { useWatch } from 'antd/es/form/Form';

const ToolbarForLayoutTwoCol: React.FC<ToolbarForLayoutTwoColProps> = ({
  createOrderSupplier = new Date(),
  onSaveDraft,
  onCancel,
  currentStep,
  handleNextStep,
  handlePrevStep,
  isPurchase = false,
  form,
  isLoading = false,
  isDisplayCreating = true,
  confirmButton = false,
  confirmButtonLabel = 'Xác nhận',
  onConfirm,
  customButton,
  statusLabel = 'Đang tạo đơn hàng mới',
  statusColor = 'var(--primaryColor500)',
}) => {
  const isDesktop = useMediaQuery({ minWidth: 1440 });
  const [userName, setUserName] = React.useState('');
  const [code, setCode] = React.useState('');

  React.useEffect(() => {
    setUserName(form.getFieldValue('userName'));
    setCode(form.getFieldValue('code'));
  }, [form]);

  return (
    <ToolbarLayout
      left={
        <Space align='center' className='gap-4 2xl:gap-6 flex-wrap'>
          <Space size='small' align='center' className='text-sm'>
            <p className='text-[var(--textBlack56)]'>Mã phiếu:</p>
            <span className='font-medium'>{useWatch('code', form) || code}</span>
          </Space>
          <Space size='small' align='center' className='text-sm'>
            <p className='text-[var(--textBlack56)]'>Người tạo:</p>
            <span className='font-medium'>{userName || ''}</span>
          </Space>
          <Space size='small' align='center' className='text-sm'>
            <p className='text-[var(--textBlack56)]'>Thời gian tạo:</p>
            <span className='font-medium'>{formatDate(createOrderSupplier || '')}</span>
          </Space>
          <Space size='small' align='center' className='text-sm'>
            {isDisplayCreating ? (
              isPurchase ? (
                <>
                  <Circle size={12} color='var(--tealColor700)' weight='fill' />
                  <p>Đang nhập hàng</p>
                </>
              ) : (
                <>
                  <Circle size={12} color={statusColor} weight='fill' />
                  <p className={`text-[${statusColor}] font-semibold`}>{statusLabel}</p>
                </>
              )
            ) : (
              <></>
            )}
          </Space>
        </Space>
      }
      right={
        <>
          <Space size='middle' align='center'>
            {onCancel && (
              <ButtonCommon
                color='basic'
                fullWidth
                radius='rounded'
                size='sm'
                className='bg-white px-0 text-black'
                onClick={onCancel}
              >
                Hủy
              </ButtonCommon>
            )}

            {currentStep > 0 && (
              <>
                {onSaveDraft && (
                  <ButtonCommon
                    color='basic'
                    fullWidth
                    radius='rounded'
                    size='sm'
                    className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2'
                    onClick={onSaveDraft}
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    <DoneRoundedIcon style={{ fontSize: '20px' }} />
                    <span className='whitespace-nowrap'>
                      {isPurchase ? (isLoading ? 'Đang lưu...' : 'Lưu đơn nhập') : 'Lưu bản nháp'}
                    </span>
                  </ButtonCommon>
                )}
                {handlePrevStep && (
                  <ButtonCommon
                    color='basic'
                    fullWidth
                    radius='rounded'
                    size='sm'
                    className='bg-[var(--bgBlackOpacity)] px-3 text-black gap-2'
                    onClick={handlePrevStep}
                  >
                    <ArrowLeft size={20} />
                    <span className='whitespace-nowrap'>{isDesktop ? 'Quay về bước trước' : 'Bước trước'}</span>
                  </ButtonCommon>
                )}
              </>
            )}
            {currentStep < 2 && handleNextStep && (
              <ButtonCommon
                color='basic'
                fullWidth
                radius='rounded'
                size='sm'
                className='bg-[var(--primaryColor500)] px-3 gap-2'
                onClick={handleNextStep}
              >
                <span className='whitespace-nowrap text-white'>
                  {isDesktop ? 'Đi đến bước tiếp theo' : 'Bước tiếp theo'}
                </span>
                <div className='w-5 h-5 '>
                  <ArrowRight size={20} />
                </div>
              </ButtonCommon>
            )}
            {currentStep === 2 && confirmButton && onConfirm && (
              <ButtonCommon
                color='primary'
                fullWidth
                radius='rounded'
                size='sm'
                loading={isLoading}
                icon={<GlobeHemisphereEast size={20} />}
                onClick={() => {
                  if (onConfirm) {
                    onConfirm();
                  }
                }}
              >
                <span className='whitespace-nowrap text-white'>{confirmButtonLabel}</span>
              </ButtonCommon>
            )}
            {customButton}
          </Space>
        </>
      }
    />
  );
};

export default ToolbarForLayoutTwoCol;
